import React from "react";

import {
  Button,
  HighlightOff,
  makeStyles,
  Paper,
} from "../../../components/shared/materials/helper";

const useStyles = makeStyles((theme) => ({
  container: {
    boxShadow: "0px 0px 88px 0px rgba(1, 41, 95, 0.04)",
    background: "white",
    fontWeight: 400,
    display: "flex",
    flexDirection: "row",
    "& h3": {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 1.5,
      color: theme.palette.primary.main,
      margin: 0,
    },
    "& p": {
      color: theme.palette.error.main,
      fontWeight: 600,
      margin: 0,
    },
  },
  textContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
  },
  iconContainer: {
    padding: 0,
    marginLeft: 10,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: theme.palette.error.main,
    opacity: 0.7,
  },
  icon: {
    color: theme.palette.error.main,
  },
}));

export default function Error({ message, onClose }) {
  const classes = useStyles();

  return (
    <Paper className={classes.container} elevation={0}>
      <span className={classes.textContainer}>
        <p>Failed</p>
        <h3>{message}</h3>
      </span>
      <Button className={classes.iconContainer} onClick={onClose}>
        <HighlightOff className={classes.icon} />
      </Button>
    </Paper>
  );
}
